import { useConfiguration } from '../../../../../../store/configurationStore';
import { SingleColumnWithDateSectionProps, DateFormatOption } from './types';

export const useSingleColumnWithDateSection = (
  props: SingleColumnWithDateSectionProps
) => {
  const { templateId, instrumentType, sectionId } = props;
  const { templates, updateSectionDateFormat, getValidationForSection } =
    useConfiguration();

  // Date format options (matching DateFormatMatchingModal)
  const dateFormatOptions: DateFormatOption[] = [
    { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY', example: '12/25/2023' },
    { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY', example: '25/12/2023' },
    { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD', example: '2023-12-25' },
    { value: 'DD-MM-YYYY', label: 'DD-MM-YYYY', example: '25-12-2023' },
    { value: 'MM-DD-YYYY', label: 'MM-DD-YYYY', example: '12-25-2023' },
    { value: 'DD.MM.YYYY', label: 'DD.MM.YYYY', example: '25.12.2023' },
    { value: 'MM.DD.YYYY', label: 'MM.DD.YYYY', example: '12.25.2023' },
    { value: 'YYYY/MM/DD', label: 'YYYY/MM/DD', example: '2023/12/25' },
  ];

  // Get the active template
  const activeTemplate = templates.find(t => t.id === templateId);

  // Get the active instrument config
  const instrumentConfig = activeTemplate?.instrumentConfigs.find(
    ic => ic.instrumentType === instrumentType
  );

  // Get the section by ID
  const dateSection = instrumentConfig?.sections.find(
    section => section.id === props.sectionId
  );

  // Get current date format from section config
  const selectedDateFormat = dateSection?.config.dateFormat || '';

  // Handle date format change
  const handleDateFormatChange = (format: string) => {
    updateSectionDateFormat(templateId, instrumentType, sectionId, format);
  };

  // Read validation from store
  const validationResult = getValidationForSection(sectionId);

  return {
    dateFormatOptions,
    selectedDateFormat,
    handleDateFormatChange,
    validationResult,
  };
};
